import React, { Component } from 'react'
import { firebase } from '../firebase'
import ContainerCrud from './ContainerCrud';


export const withUser = ComponentW => {
    class WithFromContext extends Component {
        render() {
            return <ComponentW user={firebase.auth.currentUser} {...this.props} />
        }
    }
    return WithFromContext
}


export const withContainerCrud = propsForm => ComponentW => {
    class WithFromContext extends Component {
        render() {
            return <ContainerCrud propsForm={propsForm} {...this.props} >
                <ComponentW  {...this.props} />
            </ContainerCrud>
        }
    }

    return WithFromContext
}



// WEBPACK FOOTER //
// ./src/components/Utils.js